'use client';
import { useBreakpoint } from '@cat-ecom/pcc-components';
import { PAGE_BREAKPOINTS } from '@cat-ecom/pcc-components/src/constants/commonConstants';
import { CatButton } from 'components/blocks-components';
import { useTranslations } from 'next-intl';

const ContactDealerButton = () => {
  const t = useTranslations();
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  return (
    <CatButton
      className="cat-u-margin-top-md cat-u-margin-right-md"
      size={isMD ? 'sm' : 'md'}
    >
      {t('CONTACT_YOUR_DEALER')}
    </CatButton>
  );
};

export default ContactDealerButton;
